var token = undefined
import WebService from './Webservice';

class WebPushService {

    constructor() {
        this.permissionRequest();
    }

    subscribe() {
        var $this = this;
        return navigator.serviceWorker.register('/static/js/service-worker.js')
            .then(function(registration) {
                const subscribeOptions = {
                    userVisibleOnly: true,
                    applicationServerKey: $this.urlB64ToUint8Array("BFkDjAEFNCd6eYU4JCkWogiFrHcKFZXNYRLu6Xmvy23P87alcCg5aZ0gb9h3_93Y6136fzbo2co4WowsnYO6x8g")
                };
                return registration.pushManager.subscribe(subscribeOptions);
            })
            .then(function(pushSubscription) {
                console.log('PushSubscription: ', JSON.stringify(pushSubscription));
                $this.token = JSON.stringify(pushSubscription);
                if (localStorage.getItem("token")) {
                    $this.registerToken();
                }

                return pushSubscription;
            })
    }

    permissionRequest() {
        var $this = this;
        return new Promise(function(resolve, reject) {
                const permissionResult = Notification.requestPermission(function(result) {
                    resolve(result)
                });

                if (permissionResult) {
                    permissionResult.then(resolve, reject);
                }
            })
            .then(function(permissionResult) {
                Notification.requestPermission().then(function(status) {
                    if (status === 'granted') {
                        $this.subscribe();
                    }
                });
            });
    }

    urlB64ToUint8Array(base64String) {
        const padding = '='.repeat((4 - base64String.length % 4) % 4);
        const base64 = (base64String + padding)
            .replace(/\-/g, '+')
            .replace(/_/g, '/');

        const rawData = window.atob(base64);
        const outputArray = new Uint8Array(rawData.length);

        for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    }

    registerToken() {
        if (this.token) {

            WebService.postAPI({
                    _action: "register-device",
                    _body: {
                        push_type: "WEB_PUSH",
                        token: this.token
                    },
                    _hide_error: true,
                })
                .then((res) => {})
                .catch((e) => {

                });
        }
    }

    unRegisterToken() {
        if (this.token) {
            WebService.postAPI({
                    _action: "unregister-device",
                    _body: {
                        push_type: "WEB_PUSH",
                        token: this.token
                    },
                    _hide_error: true,
                })
                .then((res) => {})
                .catch((e) => {});
        }
    }
}

export default new WebPushService({})


// WEBPACK FOOTER //
// ./src/services/WebPushService.js